import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HomeHero from './components/Hero';
import TrustBar from '../../components/sections/TrustBar';
import ServicesOverview from './components/ServicesOverview';
import AIAnswerBlock from '../../components/sections/AIAnswerBlock';
import ProcessSection from '../../components/sections/ProcessSection';
import WhyChooseUs from '../../components/sections/WhyChooseUs';
import ServiceAreas from '../../components/sections/ServiceAreas';
import Testimonials from '../../components/sections/Testimonials';
import FAQSection from '../../components/sections/FAQSection';
import FinalCTA from '../../components/sections/FinalCTA';

export default function Home() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main>
        <HomeHero />
        <TrustBar />
        <ServicesOverview />
        <AIAnswerBlock />
        <ProcessSection />
        <WhyChooseUs />
        <ServiceAreas />
        <Testimonials />
        <FAQSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
